'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dTarget from "./io.intela.sites.intelacloud.content.-Target.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Target$Mail(address, subject) {
  this.i8 = null;
  this.i9 = null;
  this.i8 = address;
  this.i9 = subject;
}
export { $c_Lio_intela_sites_intelacloud_content_Target$Mail as $c_Lio_intela_sites_intelacloud_content_Target$Mail };
$p = $c_Lio_intela_sites_intelacloud_content_Target$Mail.prototype = new $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dTarget.$h_Lio_intela_sites_intelacloud_content_Target();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Target$Mail;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Target$Mail() {
}
export { $h_Lio_intela_sites_intelacloud_content_Target$Mail as $h_Lio_intela_sites_intelacloud_content_Target$Mail };
$h_Lio_intela_sites_intelacloud_content_Target$Mail.prototype = $p;
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-1412228272), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Target$Mail)) {
    if ((this.i8 === x$0.i8)) {
      var x = this.i9;
      var x$2 = x$0.i9;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Mail";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.i8;
  }
  if ((n === 1)) {
    return this.i9;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Target$Mail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bJ)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Target$Mail as $isArrayOf_Lio_intela_sites_intelacloud_content_Target$Mail };
var $d_Lio_intela_sites_intelacloud_content_Target$Mail = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Target$Mail, "io.intela.sites.intelacloud.content.Target$Mail", ({
  bJ: 1,
  aI: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Target$Mail as $d_Lio_intela_sites_intelacloud_content_Target$Mail };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Target$-Mail.js.map
